'use strict';

const activateGuideAccount = [
  '$q',
  '$http',
  'userModel',
  'utils',

  function ($q, $http, userModel, utils) {
    return (() => {
      return new $q((resolve, reject) => {
        $http.get(utils.getApiUrlV2('/users/' + String(userModel.item.id + '/activate_guide_account')))
          .then(() => {
            resolve();
          })
          .catch(reject);
      });
    });
  }
];

export default activateGuideAccount;



// WEBPACK FOOTER //
// ./app/src/services/activate_guide_account.js